var map = {
	"./aed.webp": 1234,
	"./afn.webp": 6159,
	"./all.webp": 1935,
	"./amd.webp": 7258,
	"./ang.webp": 3148,
	"./aoa.webp": 8707,
	"./ars.webp": 812,
	"./aud.webp": 4386,
	"./awg.webp": 2833,
	"./azn.webp": 9251,
	"./bbd.webp": 5620,
	"./bdt.webp": 9006,
	"./bgn.webp": 8651,
	"./bhd.webp": 6522,
	"./bif.webp": 3057,
	"./bmd.webp": 8851,
	"./bnd.webp": 2040,
	"./bob.webp": 5463,
	"./brl.webp": 4540,
	"./bsd.webp": 7377,
	"./btn.webp": 3380,
	"./bwp.webp": 7721,
	"./byn.webp": 5465,
	"./bzd.webp": 4556,
	"./cad.webp": 2712,
	"./cdf.webp": 9631,
	"./chf.webp": 6371,
	"./clp.webp": 2421,
	"./cny.webp": 7048,
	"./cop.webp": 2846,
	"./crc.webp": 6526,
	"./cup.webp": 4368,
	"./cve.webp": 8100,
	"./czk.webp": 3406,
	"./djf.webp": 5024,
	"./dkk.webp": 3674,
	"./dop.webp": 8935,
	"./dzd.webp": 6578,
	"./egp.webp": 3444,
	"./ern.webp": 8135,
	"./etb.webp": 5705,
	"./eur.webp": 4760,
	"./fjd.webp": 5896,
	"./fkp.webp": 3505,
	"./gbp.webp": 7315,
	"./gel.webp": 664,
	"./ggp.webp": 3810,
	"./ghs.webp": 3072,
	"./gip.webp": 1040,
	"./gmd.webp": 2379,
	"./gnf.webp": 8205,
	"./gtq.webp": 6478,
	"./gyd.webp": 7900,
	"./hkd.webp": 2779,
	"./hnl.webp": 874,
	"./hrk.webp": 2867,
	"./htg.webp": 3001,
	"./huf.webp": 9215,
	"./idr.webp": 8229,
	"./ils.webp": 5298,
	"./imp.webp": 3870,
	"./inr.webp": 9531,
	"./iqd.webp": 9078,
	"./irr.webp": 5751,
	"./isk.webp": 5289,
	"./jep.webp": 5759,
	"./jmd.webp": 4971,
	"./jod.webp": 1325,
	"./jpy.webp": 5929,
	"./kes.webp": 4149,
	"./kgs.webp": 9967,
	"./khr.webp": 5927,
	"./kmf.webp": 9966,
	"./kpw.webp": 448,
	"./krw.webp": 9146,
	"./kwd.webp": 8706,
	"./kyd.webp": 280,
	"./kzt.webp": 3395,
	"./lak.webp": 4688,
	"./lbp.webp": 750,
	"./lkr.webp": 8245,
	"./lrd.webp": 898,
	"./lsl.webp": 6727,
	"./lyd.webp": 1881,
	"./mad.webp": 9762,
	"./mdl.webp": 2627,
	"./mga.webp": 7087,
	"./mkd.webp": 4876,
	"./mmk.webp": 739,
	"./mnt.webp": 5637,
	"./mop.webp": 6116,
	"./mro.webp": 556,
	"./mur.webp": 9296,
	"./mvr.webp": 8959,
	"./mwk.webp": 9553,
	"./mxn.webp": 7401,
	"./myr.webp": 6148,
	"./mzn.webp": 5191,
	"./nad.webp": 9075,
	"./ngn.webp": 2503,
	"./nio.webp": 6178,
	"./nok.webp": 864,
	"./npr.webp": 9720,
	"./nzd.webp": 6528,
	"./omr.webp": 3982,
	"./pab.webp": 7071,
	"./pen.webp": 399,
	"./pgk.webp": 7434,
	"./php.webp": 3284,
	"./pkr.webp": 3897,
	"./pln.webp": 2166,
	"./pyg.webp": 7944,
	"./qar.webp": 8896,
	"./ron.webp": 931,
	"./rsd.webp": 5153,
	"./rub.webp": 7585,
	"./rwf.webp": 5059,
	"./sar.webp": 5369,
	"./sbd.webp": 8291,
	"./scr.webp": 1464,
	"./sek.webp": 3989,
	"./sgd.webp": 5882,
	"./shp.webp": 569,
	"./sll.webp": 1401,
	"./sos.webp": 7743,
	"./srd.webp": 147,
	"./std.webp": 425,
	"./svc.webp": 74,
	"./syp.webp": 284,
	"./szl.webp": 2803,
	"./thb.webp": 3498,
	"./tjs.webp": 7103,
	"./tmt.webp": 77,
	"./tnd.webp": 7134,
	"./top.webp": 7412,
	"./try.webp": 9305,
	"./ttd.webp": 6168,
	"./twd.webp": 2979,
	"./tzs.webp": 3311,
	"./uah.webp": 4798,
	"./ugx.webp": 4972,
	"./usd.webp": 9644,
	"./uyu.webp": 9373,
	"./uzs.webp": 4120,
	"./vef.webp": 409,
	"./vnd.webp": 2892,
	"./vuv.webp": 8233,
	"./wst.webp": 8754,
	"./xaf.webp": 4219,
	"./xcd.webp": 51,
	"./xof.webp": 4457,
	"./xpf.webp": 4266,
	"./yer.webp": 532,
	"./zar.webp": 4389,
	"./zmw.webp": 8202
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8871;